import React, { createContext, useContext, useCallback } from "react";

const TranslationContext = createContext({
  lang: "en",
  dir: "ltr",
  prefix: "",
  translations: {},
  originalPath: "/",
  alternateUrls: [],
  t: (key, fallback) => fallback || key,
});

export function TranslationProvider({ lang, dir, prefix, translations, originalPath, alternateUrls, children }) {
  const t = useCallback(
    (key, fallback) => {
      const value = translations[key];
      if (value !== undefined && value !== null) return value;
      return fallback !== undefined ? fallback : key;
    },
    [translations]
  );

  const value = {
    lang: lang || "en",
    dir: dir || "ltr",
    prefix: prefix || "",
    translations: translations || {},
    originalPath: originalPath || "/",
    alternateUrls: alternateUrls || [],
    t,
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  return useContext(TranslationContext);
}
